const genres = [
  { name: "Blues", code: "blues"},
  { name: "Classical", code: "classical" },
  { name: "Country", code: "country" },
  { name: "EDM", code: "edm" },
  { name: "Folk", code: "folk" },
  { name: "Funk", code: "funk" },
  { name: "Hip Hop", code: "hiphop" },
  { name: "Indie", code: "indie" },
  { name: "Jazz", code: "jazz" },
  { name: "Metal", code: "metal" },
  { name: "Pop", code: "pop" },
  { name: "Punk", code: "punk" },
  { name: "R&B", code: "rnb" },
  { name: "Rock", code: "rock" },
  { name: "Soul", code: "soul" }
];

export default genres;